import { useEffect } from 'react';
import { useTaskFilterStore } from '../store/useTaskFilterStore';

// slice 02.1 · c.2 — companion hook for `useTaskFilterStore`. Triggers the hydrate-once fetch
// (was a `UserProvider` effect keyed on `user.dbId`) and wraps `setUsers` with the POST-back
// persistence (was `UserContext`'s `updateTaskFilterUsers`) — same shape as the old
// `useUser().taskFilterUsers`/`setTaskFilterUsers` pair, so consumers only change their import.
export function useTaskFilterUsers(dbId) {
    const taskFilterUsers = useTaskFilterStore((s) => s.users);
    const setUsersInStore = useTaskFilterStore((s) => s.setUsers);
    const hydrate = useTaskFilterStore((s) => s.hydrate);

    useEffect(() => {
        hydrate(dbId);
    }, [dbId, hydrate]);

    const setTaskFilterUsers = (newUsers) => {
        setUsersInStore((prev) => {
            const nextVal = typeof newUsers === 'function' ? newUsers(prev) : newUsers;
            if (dbId) {
                fetch('/api/customs', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userId: dbId, key: 'task_filter_users', value: nextVal }),
                }).catch((err) => console.error('Error saving custom filters', err));
            }
            return nextVal;
        });
    };

    return { taskFilterUsers, setTaskFilterUsers };
}
